module.exports = __webpack_public_path__ + "static/hero-92b56d874e4b873f9560b9f87ec691de.svg";